ACC.orderstatus = {
    _autoload: [
        ['bindOrderStatusSubmitOnClick', $('[data-recaptcha-control="getOrderStatusRecaptcha"]').length !== 0],
        ['toggleCheckAnother', $('.order-status-details-body').length !== 0],
        ['bindSearchStatusButton', $("input[name='orderNumber']").length !== 0],
        ['addAttributes', document.querySelector('#orderNumber\\.errors')
        && document.querySelector('[name="orderNumber"]') && ACC.utils.isHedTheme()],
    ],

    bindSearchStatusButton() {
        const orderNumberSearchInput = $("input[name='orderNumber']");
        const inputState = function () {
            $('#orderStatusBtn').prop('disabled', orderNumberSearchInput.val().length === 0);
        };
        orderNumberSearchInput.bind('input propertychange', () => {
            inputState();
        });
        inputState();
    },

    toggleCheckAnother() {
        $("input[name='orderNumber']").val('');
    },

    bindOrderStatusSubmitOnClick() {
        $('#orderStatusBtn').click(() => {
            // eslint-disable-next-line no-undef
            grecaptcha.execute();
            return false;
        });
    },

    orderStatusSubmitForm() {
        const form = $('#getOrderStatusForm');
        if (form.valid()) {
            form.submit();
        }
    },

    addAttributes() {
        const orderError = document.querySelector('#orderNumber\\.errors');
        const orderField = document.querySelector('[name="orderNumber"]');
        orderField.setAttribute('aria-describedby', orderError.id);
        orderField.focus();
    },
};

// eslint-disable-next-line no-unused-vars
const recaptchaOrderStatusSubmitCallback = function () {
    ACC.orderstatus.orderStatusSubmitForm();
};
